import React, { useState, useEffect } from 'react'

import clsx from 'clsx'

import classes from './Avatar.module.scss'

const Avatar = ({ children, src, srcSet, referrerPolicy, crossOrigin, variant, className, alt, ...props }) => {
  const [loaded, setLoaded] = useState('')

  const hasImg = src || srcSet
  const hasImgNotFailing = hasImg && loaded !== 'error'

  useEffect(() => {
    if (!src && !srcSet) {
      return undefined
    }

    let active = true
    const image = new Image()
    image.onload = () => {
      if (!active) {
        return
      }
      setLoaded('loaded')
    }
    image.onerror = () => {
      if (!active) {
        return
      }
      setLoaded('error')
    }
    image.crossOrigin = crossOrigin
    image.referrerPolicy = referrerPolicy
    image.src = src
    if (srcSet) {
      image.srcset = srcSet
    }

    return () => {
      active = false
    }
  }, [crossOrigin, referrerPolicy, src, srcSet])

  return (
    <div className={clsx('Avatar', classes.root, classes[variant], className)} {...props}>
      {hasImgNotFailing ? (
        <img
          className={classes.avatarImg}
          src={src}
          crossOrigin={crossOrigin}
          alt={alt || 'Verified reviewer profile picture'}
          referrerPolicy={referrerPolicy}
          loading="lazy"
        />
      ) : (
        children
      )}
    </div>
  )
}

export default Avatar
